<template>
  <div class="noticeDetail">
    <!-- <Header :msg.sync='title' :type.sync='type'/> -->
    <!-- <div style="height:0.44rem;"></div> -->
    <div class="home-header flex flex-a-i-center" v-if="inviterInf.id">
       <img :src="inviterInf.avatar_url">
       <div class="header-text flex flex-j-c-center">
           <p class="text-top">您的好友 <i>{{inviterInf.true_name || inviterInf.nickname}}</i></p>
           <p>邀请您一起来提升学历</p>
       </div>
    </div>
    <div class="detail-con">
        <h3>{{pageData.title}}</h3>
        <p><span class="detail-con-left">来源：陈文卫小编</span><span class="detail-con-right">时间：{{pageData.addtime}}</span></p>
        <div v-html="pageData.content"></div>
        <!-- <div class="Invitation-herf flex flex-a-i-center" v-if="inviterInf.id">
          <img :src="inviterInf.avatar_url">
          <p class="ellipsis text-yellow">你的好友 {{inviterInf.nickname}} 邀请你来读大学~</p>
        </div> -->
    </div>
    <div class="home-footer flex flex-a-i-center flex-j-c-center">
        <p>{{bottomTips}}</p>
        <div class="footer-btn" @click="_MEIQIA('showPanel')">点击咨询</div>
        <!-- <div class="footer-btn">点击咨询</div> -->
        <div @click="toEnrolment">我要报名</div>
    </div>
    <!-- <div class="shareBtn" @click="showMask = true">
      <img src="@/assets/share.png" />
    </div> -->
    <div class="mask" v-show="showMask" @touchmove.prevent @click="showMask = false">
      <!-- <img src="@/assets/rightTop.png" class="shareImg"/> -->
      <img src="@/assets/shareimg.png" class="shareImg"/>
      <div class="shareTips">
        <p>点击这里</p>
        <p>分享内容</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { Toast } from 'mint-ui';
import {NoticeDetails, inviterInfo, becomefans, pageShare} from '@/api';

export default {
  name: 'NoticeDetail',
  components: {
    Header
  },
  data() {
    return {
      title: '', // 文章标题
      pageData: '', // 页面数据
      inviterInf: {}, // 邀请信息
      type: 'myNotice', // 页面类型
      showMask: false, // 分享引导
      bottomTips: '' // 底部提示文字
    }
  },
  created() {
    this.getDetail();
    let uid = JSON.parse(localStorage.getItem('cww_data')).id;
    if (sessionStorage.getItem('_shareid')) {
      this.isfans(sessionStorage.getItem('_shareid'));
      this.getInviterInfo(sessionStorage.getItem('_shareid'));
    }
    if (this.$route.query.invitorId && (String(this.$route.query.invitorId) !== String(uid))) {
      sessionStorage.setItem('_shareid', String(this.$route.query.invitorId));
      localStorage.setItem('_lastshareid', String(this.$route.query.invitorId));
      window.location.href = `${window.location.origin}/NoticeDetail?id=${this.$route.query.id}&invitorId=${uid}`;
      // this.getInviterInfo();
      // this.isfans();
      this.type = 'Notice';
    } else {
      if (String(this.$route.query.invitorId) === String(uid)) {
        if (this.$route.query.type === 'invi') {
          this.getInviterInfo(uid);
        }
      }
    }
  },
  mounted () {
    this.bottomTips = window._cwwConfigData ? window._cwwConfigData.bottomItem : '上大学，到陈文卫'
  },
  methods: {
    // 获取文章详情
    getDetail() {
      NoticeDetails({id: this.$route.query.id}).then(res => {
        if (res.code !== 0) { Toast({message: res.msg, className: 'iconfont icon-close', duration: 1500}); }
        this.pageData = res.data;
        var tit = document.getElementsByTagName('title')[0];
				tit.innerText=res.data.title;
        this.pageData.content = this.pageData.content.replace(/\<img/gi, '<img style="max-width:100%;width:100%;margin-top:10px;margin-bottom:10px;height:auto"');
        this.title = res.data.title;
        this.pageCon();
      })
    },
    // 分享初始化
    pageCon() {
      let udata = JSON.parse(localStorage.getItem('cww_data'));
      pageShare({url: `${window.location.href}`}).then(res => {
        if (this._tools.isWechat()) {
          let params = {
            appId: res.data.appid,
            timestamp: res.data.timestamp,
            nonceStr: res.data.noncestr,
            signature: res.data.signature,
            imgUrl: this.pageData.cover_pic,
            link: `${window.location.origin}/NoticeDetail?id=${this.pageData.id}&invitorId=${udata.id}&type=invi`,
            desc: this.pageData.desc_content || `限时领取礼包 985 / 211 名校大专本科学历，社会认可、全网可查、含金量高！每月200元，轻松拿无压力拿文凭！`,
            title: this.title,
          }
          this._tools.wechatShareConfig(params);
        }
      })
    },
    // 跳转报名
    toEnrolment() {
      // this.$router.push({name:'Enrolment'});
      let uid = JSON.parse(localStorage.getItem('cww_data')).id;
      window.location.href = `${window.location.origin}/home?id=${uid}`;
    },
    // 邀请人信息
    getInviterInfo(id) {
      inviterInfo({inviter_id: id, require: 0}).then(res => {
        this.inviterInf = res.data.userInfo;
        localStorage.setItem('_lastshareUser', JSON.stringify(res.data.userInfo));
      })
    },
    // 成为粉丝
    isfans(id) {
      if (String(id) === String(this.$route.query.invitorId)) {
        return false;
      }
      becomefans({inviter_id: id}).then(res => {
        // if (res.code !== 0) { Toast({message: res.msg, className: 'iconfont icon-close', duration: 1500}); }
        sessionStorage.removeItem("_shareid");
        // if (res.code == 1) {
        //   localStorage.removeItem('_lastshareid');
        // }
      })
    },
    // 调用客服系统
    _MEIQIA(e) {
      // window._MEIQIA(e)
      window.location.href = 'https://live.easyliao.com/live/chat.do?c=13277&g=26590&config=40265&chatUrl=成高系统';
    },
  },
  watch: {
  },
  destroyed() {
    var tit = document.getElementsByTagName('title')[0];
    tit.innerText='陈文卫成人高考';
  }
};
</script>

<style lang="less" scoped>
  .noticeDetail{
    background: #F6F6FA;
    min-height: 100vh;
    .home-header{
        width: 100%;
        height: 0.66rem;
        background: #F0F0F0;
        img{
            width: 0.45rem;
            height: 0.45rem;
            margin-left: 0.36rem;
            border-radius: 50%;
        }
        .header-text{
            flex-direction: column;
            text-align: left;
            margin-left: 0.13rem;
            color: #333333;
            font-size: 0.16rem;
            .text-top{
                font-size: 0.12rem;
                i{
                    color: #E9784A;
                    font-style: normal;
                }
            }
        }

    }
    .detail-con{
        border-top: 0.01rem solid #eeeeee;
        padding: 0.16rem 0.16rem 0.54rem;
        background: white;
        text-align: left;
        h3{
          color: #333333;
          font-size: 0.21rem;
        }
        p{
          font-size: 0.12rem;
          padding: 10px 0;
          border-bottom: 1px solid #ddd;
          height: 28px;
          margin-top: 10px;

          span {
            color: #666666;
          }
          .detail-con-left {
            float: left;
            text-align: left;
          }
          .detail-con-right {
            float: right;
            text-align: right;
          }
        }

        div{
          font-size: 0.14rem;
        }
        .Invitation-herf{
          position: absolute;
          top: 0.44rem;
          // left: 0;
          width: 100%;
          background: rgba(255, 221, 113, 0.2);
          margin: 0 -0.16rem;
          padding: 0 0.16rem;
          height: 0.25rem;
          img{
            width: 0.2rem;
            height: 0.2rem;
            border-radius: 50%;
            margin-right: 0.07rem;
          }
          p{
            width: 80%;
            text-align: left;
            color: #FA8801;
          }
        }
    }
    .home-footer{
        width: 100%;
        height: 0.5rem;
        background: white;
        border-top: 1px solid #EEEEEE;
        position: fixed;
        bottom: 0;
        left: 50%;
        font-size: 0.14rem;
        max-width: 640px;
        transform: translateX(-50%);
        p{
            width: 52%;

        }
        div{
            width: 24%;
            background: #F2591B;
            color: white;
            height: 0.5rem;
            line-height: 0.5rem;
        }
        .footer-btn{
            background: #F2A91B;
        }
    }
    .shareBtn{
      width: 0.42rem;
      height: 0.42rem;
      position: fixed;
      bottom: 0.6rem;
      right: 0.1rem;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.3);
      img{
        width: 0.30rem;
        height: 0.30rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
    }
    .shareImg{
      width: 1.06rem;
      height: 1.39rem;
      position: absolute;
      right: 0.25rem;
      top: 0;
    }
    .shareTips{
      color: white;
      position: absolute;
      top: 1.39rem;
      right: 1rem;
      font-size: 0.18rem;
      letter-spacing: 1px;
    }
  }
</style>
